"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesSubjectToScreeningRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.RolesSubjectToScreeningRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.roles_subject_to_screening.label',
    fallbackLabel: 'Roles subject to PEP screening',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'ULTIMATE_BENEFICIAL_OWNERS', label: 'fields.enm.roles_subject_to_screening.options.ULTIMATE_BENEFICIAL_OWNERS', fallbackLabel: 'Ultimate Beneficial Owners' },
        { key: 'AUTHORIZED_SIGNATORIES', label: 'fields.enm.roles_subject_to_screening.options.AUTHORIZED_SIGNATORIES', fallbackLabel: 'Authorized signatories' },
        { key: 'PERSONS_WITH_MATERIAL_INFLUENCE_OVER_THE_COMPANY', label: 'fields.enm.roles_subject_to_screening.options.PERSONS_WITH_MATERIAL_INFLUENCE_OVER_THE_COMPANY', fallbackLabel: 'Persons with material influence over the company / Key controllers' },
        { key: 'ADDITIONAL_OTHER_INDIVIDUALS', label: 'fields.enm.roles_subject_to_screening.options.ADDITIONAL_OTHER_INDIVIDUALS', fallbackLabel: 'Additional other individuals' },
    ],
    trackFieldValueWithAnalytics: false,
};
